import { environment } from "./environments/environment";

if (environment.environment_name === 'prd' || environment.environment_name === 'tst') {
console.log('Datadog RUM initialized:');
console.log('env:', environment.datadogEnv);
(function (h, o, u, n, d) {
    (h as any)[d] = (h as any)[d] || { q: [], onReady: function (c: any) { (h as any)[d].q.push(c); } };
    const e = o.createElement(u) as HTMLScriptElement;
    e.async = true;
    e.src = n;
    const s = o.getElementsByTagName(u)[0];
    s.parentNode.insertBefore(e, s);
})(window, document, 'script', 'https://www.datadoghq-browser-agent.com/us3/v5/datadog-rum.js', 'DD_RUM');
(window as any).DD_RUM.onReady(function () {
    (window as any).DD_RUM.init({
      clientToken: environment.datadogClientToken,
      applicationId: environment.datadogAppId,
      // `site` refers to the Datadog site parameter of your organization
      // see https://docs.datadoghq.com/getting_started/site/
      site: 'us3.datadoghq.com',
      service: 'iot-device-admin-dashboard',
      env: environment.datadogEnv,
      // Specify a version number to identify the deployed version of your application in Datadog
      // version: '1.0.0',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      allowedTracingUrls: [/https:\/\/.*\.culliganiot\.com/],
    });
});} else {
    console.log('Datadog RUM not initialized in development mode');
}